"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
const log = require("loglevel");
class Logger {
    constructor(context) {
        this.context = context;
        const name = context ?? `logger-${Date.now()}-${Math.random()}`;
        this._logger = log.getLogger(name);
        this._logger.setLevel(log.levels.DEBUG);
        const prefix = this.prefix();
        if (prefix) {
            // With context prefix: bind console methods with the prefix as first arg
            this.log = console.log.bind(console, prefix);
            this.debug = console.debug.bind(console, prefix);
            this.info = console.info.bind(console, prefix);
            this.warn = console.warn.bind(console, prefix);
            this.error = console.error.bind(console, prefix);
        }
        else {
            // No context: bind console methods directly
            this.log = console.log.bind(console);
            this.debug = console.debug.bind(console);
            this.info = console.info.bind(console);
            this.warn = console.warn.bind(console);
            this.error = console.error.bind(console);
        }
    }
    static create(context) {
        return new Logger(context);
    }
    setLevel(level) {
        this._logger.setLevel(level);
        const isActive = this._logger.getLevel() <= log.levels.DEBUG;
        const prefix = this.prefix();
        if (isActive) {
            if (prefix) {
                this.log = console.log.bind(console, prefix);
                this.debug = console.debug.bind(console, prefix);
                this.info = console.info.bind(console, prefix);
                this.warn = console.warn.bind(console, prefix);
                this.error = console.error.bind(console, prefix);
            }
            else {
                this.log = console.log.bind(console);
                this.debug = console.debug.bind(console);
                this.info = console.info.bind(console);
                this.warn = console.warn.bind(console);
                this.error = console.error.bind(console);
            }
        }
        else {
            this.log = (..._args) => { };
            this.debug = (..._args) => { };
            this.info = (..._args) => { };
            this.warn = (..._args) => { };
            this.error = (..._args) => { };
        }
    }
    prefix() {
        return this.context ? `[${this.context}]` : '';
    }
}
exports.Logger = Logger;
